// NPM Imports
import React from "react";
import CreatableSelect from "react-select/lib/Creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "../../../../revvComponents";

// Components Imports
import SourceField from "../MapperBlock/SourceField";
import FieldFormatOptions from "./FieldFormatOptions";

// Internal Imports
import { FIELDS } from "../../../../constants";

// Destructuring
const { TRANSFORMATION_LIST } = FIELDS;

const SourceFieldsTransform = ({
  sourceFields,
  sourceFieldsWithDefs,
  updateFieldTransform,
  selectFormat,
  selectedFormat,
  isRevvFieldFreeTextClause,
}) => {
  const _handleSFTransform = (sourceFieldIndex, transformList) => {
    updateFieldTransform(sourceFieldIndex, transformList);
  };

  const _transformView = sourceFieldIndex => {
    const { transform: tranformerList = [] } =
      Array.isArray(sourceFields) && sourceFields.length > sourceFieldIndex
        ? sourceFields[sourceFieldIndex]
        : {};

    const _updateSourceFieldTransform = (transformIndex, transformValue) => {
      const { transform: updatedTransList = [] } =
        sourceFields[sourceFieldIndex];
      if (transformIndex < updatedTransList.length) {
        updatedTransList[transformIndex] = transformValue;
      } else {
        updatedTransList.push({
          ...transformValue,
        });
      }
      _handleSFTransform(sourceFieldIndex, updatedTransList);
    };

    if (!(tranformerList.findIndex(trans => trans.operation === null) > -1))
      tranformerList.push({
        operation: null,
      });

    const transformerListView = tranformerList.map(
      (transform, transformIndex) => {
        const { operation } = transform;

        const operationObj = operation
          ? TRANSFORMATION_LIST.find(trans => trans.value === operation)
          : null;

        const _updateTransformOperation = value => {
          const transformOps = {
            operation: value ? value.value : null,
          };
          // handleSelectedValues(value);
          _updateSourceFieldTransform(transformIndex, transformOps);
        };

        const _onRemoveTransformation = () => {
          const transformOps = {
            operation: null,
          };
          tranformerList.splice(transformIndex, 1);
          _updateSourceFieldTransform(transformIndex, transformOps);
        };

        const _updateTransformInputValue = (key, value) => {
          const transObj = {
            ...tranformerList[transformIndex],
            [key]: value,
          };
          _updateSourceFieldTransform(transformIndex, transObj);
        };
        const transformLabelView = (
          <CreatableSelect
            isSearchable={false}
            style={{
              height: "10px",
            }}
            isDisabled={false}
            options={TRANSFORMATION_LIST}
            value={operationObj}
            onChange={_updateTransformOperation}
            data-test="merge-settings"
            isOptionDisabled={option => !option.active}
          />
        );

        const inputBoxView =
          operationObj &&
          operationObj.input_required &&
          Array.isArray(operationObj.input_list)
            ? operationObj.input_list.map(inputVal => (
                <div className="transform-input">
                  <div className="transform-input-label">
                    {inputVal.input_label}{" "}
                  </div>
                  <Input
                    className="transform-input-box"
                    data-test="transform-input-box"
                    type={inputVal.input_type}
                    value={transform[inputVal.input_name]}
                    placeholder={inputVal.input_placeholder}
                    onChange={event =>
                      _updateTransformInputValue(
                        inputVal.input_name,
                        event.target.value,
                      )
                    }
                  />
                </div>
              ))
            : null;

        return (
          <div className="source-field-transform-view">
            <div className="source-field-operation-view">
              <div className="source-field-operation">{transformLabelView}</div>
            </div>
            <div className="transform-input-list">{inputBoxView}</div>
            {tranformerList.length > 1 &&
              transformIndex !== tranformerList.length - 1 && (
                <div
                  className="remove-transformation"
                  onClick={() => _onRemoveTransformation(operationObj)}
                  onKeyPress={() => {}}
                  role="button"
                  data-test="remove-transformation"
                  tabIndex="0">
                  <FontAwesomeIcon icon={["far", "trash-alt"]} />
                </div>
              )}
          </div>
        );
      },
    );

    return (
      <div className="source-field-transform-list">{transformerListView}</div>
    );
  };

  const _isMultiRefrenceSource = field => {
    if (field && field.parent_field_type === "multi_reference") {
      return true;
    }
    return false;
  };

  return (
    <div className="transform-settings-body">
      <div className="transform-settings-merge">
        <div className="transform-settings-merge-body">
          {Array.isArray(sourceFields) &&
            sourceFields.map((sf, index) => (
              <>
                <div className="transform-settings-merge-field">
                  <div className="transform-settings-merge-title">
                    {`Salesforce Field ${index + 1}`}
                  </div>
                  <SourceField
                    title={
                      sourceFieldsWithDefs.find(f => f.name === sf.name).label
                    }
                    draggable={false}
                    isRemoveAllowed={false}
                  />
                  {/* select options to transfer */}
                  <div className="transform-settings-merge-field-title">
                    Transform
                  </div>
                  {_transformView(index)}

                  {/* Render field formatting options if source field 
                  is a "multi_reference" and revv field is a "free text clause" */}
                  {isRevvFieldFreeTextClause &&
                    _isMultiRefrenceSource(
                      sourceFieldsWithDefs.find(f => f.name === sf.name),
                    ) && (
                      <FieldFormatOptions
                        selectFormat={selectFormat}
                        selectedFormat={selectedFormat}
                        sourceFieldName={sf.name}
                      />
                    )}
                </div>
              </>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SourceFieldsTransform;
